// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  height: 100%;
  margin: 0;
}

.layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.layout main {
  flex: 1 1;
}

.footer a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: all 0.2s ease;
}

/* Hover effect for regular links and React Router links */
.footer a:hover,
.footer .nav-link:hover {
  color: #007bff !important;
  transform: translateY(-2px);
}

/* Smooth transition for icons */
.footer i {
  transition: all 0.2s ease;
}

/* Slightly enlarge icons on hover */
.footer a:hover i {
  transform: scale(1.15);
}

/* Prevent logo from jumping on hover */
.footer a img {
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;
}

.footer a:hover img {
  transform: scale(1.05);
  opacity: 0.9;
}

.footer small:hover,
.footer link:hover {
  color: rgba(255, 255, 255, 0.91);
  transition: color 0.2s ease;
}

.hover-image {
  transition: all 0.2s ease;
}

.hover-image:hover {
  transform: translateY(-3px) scale(1.03);
}

.png-shadow {
  filter: drop-shadow(0 8px 12px rgba(0, 0, 0, 0.6));
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout.css"],"names":[],"mappings":"AAAA;;;EAGE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,0DAA0D;AAC1D;;EAEE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;EACE;;qBAEmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD","sourcesContent":["html,\nbody,\n#root {\n  height: 100%;\n  margin: 0;\n}\n\n.layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.layout main {\n  flex: 1;\n}\n\n.footer a {\n  color: rgba(255, 255, 255, 0.6);\n  text-decoration: none;\n  transition: all 0.2s ease;\n}\n\n/* Hover effect for regular links and React Router links */\n.footer a:hover,\n.footer .nav-link:hover {\n  color: #007bff !important;\n  transform: translateY(-2px);\n}\n\n/* Smooth transition for icons */\n.footer i {\n  transition: all 0.2s ease;\n}\n\n/* Slightly enlarge icons on hover */\n.footer a:hover i {\n  transform: scale(1.15);\n}\n\n/* Prevent logo from jumping on hover */\n.footer a img {\n  transition:\n    transform 0.2s ease,\n    opacity 0.2s ease;\n}\n\n.footer a:hover img {\n  transform: scale(1.05);\n  opacity: 0.9;\n}\n\n.footer small:hover,\n.footer link:hover {\n  color: rgba(255, 255, 255, 0.91);\n  transition: color 0.2s ease;\n}\n\n.hover-image {\n  transition: all 0.2s ease;\n}\n\n.hover-image:hover {\n  transform: translateY(-3px) scale(1.03);\n}\n\n.png-shadow {\n  filter: drop-shadow(0 8px 12px rgba(0, 0, 0, 0.6));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
